import React, {useState} from "react";
import { useObjectStore } from "../zustand/objects";
import { ActionIcon } from '@mantine/core';

import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';

const ChangePreviewArtboard = () => {
    const {
        currentObjectArtboard,
        updateArtboard,
        artboards,
        storyboardFields
    } = useObjectStore();

const artboardsAmount = Object.keys(artboards).length

const [hover1, setHover1] = useState(false)
const [hover2, setHover2] = useState(false)
 
    return (
        <div
            style={{
                width:'100%',
                display: 'flex',
                alignItems: 'center',
                height: "100%",
            }}>
            <div style={{
                paddingLeft:15,
            }}>{currentObjectArtboard}: {storyboardFields[currentObjectArtboard].name}</div>
            <ActionIcon ml={5} w={30}  variant="transparent" size={'xs'}
            onPointerOver={() => setHover1(true)}
            onPointerLeave={() => setHover1(false)}
                        color={!hover1 ? "#424242" : "#868e96"}  disabled={parseInt(currentObjectArtboard, 10) === 1}  onClick={ () => updateArtboard(Number(currentObjectArtboard) - 1)} >
                            <IconArrowLeft size={18} /></ActionIcon>
            <ActionIcon ml={5} mr={5} w={30}  variant="transparent" size={'xs'}
            onPointerOver={() => setHover2(true)}
            onPointerLeave={() => setHover2(false)}
                        color={!hover2 ? "#424242" : "#868e96"}  disabled={artboardsAmount <= parseInt(currentObjectArtboard, 10)} onClick={ () => updateArtboard(Number(currentObjectArtboard) + 1)} >
                            <IconArrowRight size={18} /></ActionIcon>
        </div>
    ); 
};

export default ChangePreviewArtboard;
